'use strict';

angular
	.module('storyApp')
	.controller('PageCtrl', PageController);

PageController.$inject = ['$location'];

function PageController($location){
	// set storyIndex to -1 to prevent scrolling to different stories of threethings
	$location.state({ storyIndex: -1 });
}



// WEBPACK FOOTER //
// ./assets/components/threethings/controllers/pageCtrl.js